import { Tooltip } from "antd";
import dayjs from "dayjs";
import { formatAmount } from "../../../utils/appUtils";

export const CONSULTATION_HEADER_COLUMNS = ({ consultationActiveTab, consultationActionRender, getConsultationDropdown, configGstPercentage }) => [
    {
        title: "SNo",
        width: 50,
        align: "center",
        render: (_, detail, index) => <div style={{ textAlign: "center" }}>{index + 1}</div>
    },
    {
        title: "Cons. ID",
        width: 120,
        align: "center",
        dataIndex: "consultationNo",
    },
    {
        title: "Advocate ID",
        width: 120,
        align: "center",
        render: (detail) => <>{detail?.lawyerResponse?.lawyerNo}</>
    },
    {
        title: "Cons. Date",
        align: "center",
        width: 120,
        dataIndex: "consultationDate",
        render: (_, detail) => <>{dayjs(detail?.consultationDate).format("DD-MM-YYYY")}</>
    },
    {
        title: "Cons.Time",
        align: "center",
        dataIndex: "consultationTime",
        width: 80,
        render: (_, detail) => <>{detail?.consultationTime} min</>
    },
    {
        title: "Start Time",
        width: 100,
        align: "center",
        dataIndex: "consultationStartTime",
        render: (_, detail) => {
            if (!detail?.consultationStartTime) return "-";
            const time = dayjs(detail?.consultationStartTime).format("hh:mm A");
            return <>{time}</>
        }

    },
    {
        title: "End Time",
        align: "center",
        dataIndex: "consultationEndTime",
        width: 100,
        render: (_, detail) => {
            if (!detail?.consultationEndTime) return "-";
            const time = dayjs(detail?.consultationEndTime).format("hh:mm A")
            return <>{time}</>
        }
    },
    {
        title: "Specialization",
        align: "center",
        width: 150,
        render: (detail) => {
            const specs = detail?.specialization || [];
            const joinedSpecs = specs?.join(", ");
            const displayText =
                specs?.length > 2 ? `${specs?.slice(0, 2)?.join(", ")}...` : joinedSpecs;

            return (
                <Tooltip title={joinedSpecs}>
                    <span>{displayText}</span>
                </Tooltip>
            );
        }
    },
    {
        title: "Add on",
        align: "center",
        width: 120,
        render: (detail) => {
            const addOns = detail?.consultationPaymentDetails?.addOnList?.map(addonInfo => addonInfo?.addOn) || [];
            const joinedAddOns = addOns?.join(", ");
            const displayText = addOns?.length > 1 ? `${addOns?.slice(0, 1)?.join(", ")}..` : joinedAddOns;
            if (addOns?.length > 1) {
                return (
                    <Tooltip title={joinedAddOns}>
                        <span>{displayText}</span>
                    </Tooltip>
                );
            }

            return <>{joinedAddOns}</>;
        }
    },
    ...(consultationActiveTab === "CANCELLED" || consultationActiveTab === "AUTO_CANCELLED" ? [
        {
            title: "Complaint Status",
            width: 150,
            align: "center",
            render: (detail) => {
                return <>{
                    detail?.customerComplaintDto && detail?.customerComplaintDto?.complaintStatus === "PENDING" ? <div className="pending-status"><p>Pending</p></div>
                        : detail?.customerComplaintDto && detail?.customerComplaintDto?.complaintStatus === "COMPLETED" ? <div className="success-status"><p>Completed</p></div>
                            : detail?.lawyerComplaintDto && detail?.lawyerComplaintDto?.complaintStatus === "PENDING" ? <div className="pending-status"><p>Pending</p></div>
                                : detail?.lawyerComplaintDto && detail?.lawyerComplaintDto?.complaintStatus === "COMPLETED" ? <div className="success-status"><p>Completed</p></div> : <div style={{ textAlign: "center" }}>-</div>
                }</>
            }
        },
        {
            title: "Reason for Cancellation",
            align: "center",
            width: 180,
            render: (_, detail) => {
                const reason = detail?.cancelDetails?.reason || "-";
                if (reason?.length > 30) {
                    return <Tooltip title={reason}>
                        <span>{reason?.slice(0, 30)}...</span>
                    </Tooltip>
                }
                return <><span>{reason}</span>
                </>
            }
        }
    ] : []),
    ...(consultationActiveTab === "COMPLETED" ? [{
        width: 120,
        align: "center",
        title: "Extented Time",
        render: (detail) => {
            const extendList = detail?.extendConsultionDetailsList || [];
            const totalExtendMin = extendList?.reduce((sum, extenTime) => {
                const val = Number(extenTime?.extendMin) || 0;
                return sum + val;
            }, 0);
            return <>{totalExtendMin} min</>
        }
    },
    {
        title: "Recording",
        align: "center",
        width: 150,
        render: (detail) => {
            const hasRecordedStatus = detail?.consultationPaymentDetails?.recordDetail?.record === true;
            return <>{hasRecordedStatus ? <div className="success-status"><p>Recorded</p></div> : <div className="danger-status"><p>Not Recorded</p></div>}</>
        }
    },
    {
        title: "Complaint Status",
        align: "center",
        width: 150,
        render: (detail) => {
            return <>{
                detail?.customerComplaintDto && detail?.customerComplaintDto?.complaintStatus === "PENDING" ? <div className="pending-status"><p>Pending</p></div>
                    : detail?.customerComplaintDto && detail?.customerComplaintDto?.complaintStatus === "COMPLETED" ? <div className="success-status"><p>Completed</p></div>
                        : detail?.lawyerComplaintDto && detail?.lawyerComplaintDto?.complaintStatus === "PENDING" ? <div className="pending-status"><p>Pending</p></div>
                            : detail?.lawyerComplaintDto && detail?.lawyerComplaintDto?.complaintStatus === "COMPLETED" ? <div className="success-status"><p>Completed</p></div> : <div style={{ textAlign: "center" }}>-</div>
            }</>
        }
    },
    {
        title: "Feedback",
        align: "center",
        dataIndex: "feedback",
        render: (_, detail) => {
            const feedback = detail?.feedback?.feedback || "-";
            if (feedback?.length > 40) {
                return <Tooltip title={feedback}>
                    <span>{feedback?.slice(0, 40)}...</span>
                </Tooltip>
            }
            return <><span>{feedback}</span>
            </>
        }
    },
    {
        title: "Fees",
        align: "center",
        dataIndex: "consultationPaymentDetails",
        width: 100,
        render: (_, detail) => {
            const feesAmount = Number(detail?.consultationPaymentDetails?.consultationAmountWithOutGst || 0) * Number(configGstPercentage || 0) / 100;
            return <>&#8377;{formatAmount(feesAmount)}</>
        }
    },] : []),
    {
        title: "Action",
        width: 50,
        fixed: "right",
        render: (detail) => {
            const filteredList = getConsultationDropdown(detail);
            return consultationActionRender(detail, filteredList);
        }
    }
];

export const consultationTabData = [
    { label: "Completed Cons.", content: "COMPLETED", key: "1" },
    { label: "Cancelled Cons.", content: "CANCELLED", key: "2" },
    { label: "Upcoming Cons.", content: "PENDING", key: "3" },
    { label: "Auto Cancelled Cons.", content: "AUTO_CANCELLED", key: "4" }
];